export default {"src":"/_next/static/media/SWN.f38034d5.svg","height":18,"width":18};